module.exports = __webpack_public_path__ + "static/media/gorra (8).42eb1df6.png";